

import React from "react";
import ReactDOM from "react-dom";
import "./styleSheets/sass/index.scss";
import { unregister } from "./util/registerServiceWorker";
import { Provider } from 'react-redux'
import store from './store'
import { i18nReady } from './i18n';
import App from './containers/AppContainer'
import 'semantic-ui-css/semantic.min.css'
import { getBrokerUiEnvironment } from "./util/index";
import Cookie from "./services/cookie";
import { idbPruneExpiredHtsMetadata } from './CBP_App/api/htsIDBCache';
import { apiIDBCache } from './services/apiIDBCache';
import { pruneExpiredI18nextTranslations } from './services/i18nextIDBCache';
import { showChatApp } from './ChatApp/helper';
//import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
//import { TracingInstrumentation } from '@grafana/faro-web-tracing';

const env = getBrokerUiEnvironment();
const faroApiKey = {
  'dev': '7652e713810f9972ff695e38d235e26e',
  'prod': '158253dded8b66da509b8b4759a45a95'
}
// if (env === 'dev' || env === 'prod') {
//     var faro = initializeFaro({
//         url: `https://faro-collector-prod-us-east-0.grafana.net/collect/${faroApiKey[env]}`,
//         app: {
//           name: window.location.hostname,
//           version: '1.0.0',
//           environment: env === 'prod'? 'production': 'development'
//         },
//         instrumentations: [
//           // Mandatory, overwriting the instrumentations array would cause the default instrumentations to be omitted
//           ...getWebInstrumentations(),
      
//           // Initialization of the tracing package.
//           // This packages is optional because it increases the bundle size noticeably. Only add it if you want tracing data.
//           new TracingInstrumentation(),
//         ],
//       });
// }
function waitForEngineToken(callback, maxWaitTime = 12000, checkInterval = 100) {
  if (Cookie.get(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN)) {
    callback();
    return;
  }

  const startTime = Date.now();
  let finished = false;

  const finish = () => {
    if (finished) return;
    finished = true;
    window.removeEventListener('engineTokenReady', onTokenReady);
    callback();
  };

  const onTokenReady = () => finish();

  window.addEventListener('engineTokenReady', onTokenReady);

  function checkVariable() {
    if (Cookie.get(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN)) {
      finish();
    } else if (Date.now() - startTime < maxWaitTime) {
      setTimeout(checkVariable, checkInterval);
    } else {
      console.warn('[App] Engine token not received within %sms — rendering without auth', maxWaitTime);
      finish();
    }
  }

  checkVariable();
}



function renderApp() {
  ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById("root"));
  unregister();
}

async function boot() {
  if (showChatApp()) {
    import('kn-chat-app/dist/css/main.css').catch(() => {});
  }
  const isEngineIframe = window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken';

  // Do not block first paint on i18n / IDB. i18nReady is already in flight from import.
  i18nReady.catch((e) => {
    console.error('[App] i18n init failed, continuing without preloaded translations:', e);
  });

  idbPruneExpiredHtsMetadata();
  apiIDBCache.pruneExpired();
  apiIDBCache.purgeDisabledApiEntries();
  pruneExpiredI18nextTranslations().catch((e) => {
    console.warn('[App] i18next prune failed:', e);
  });

  if (isEngineIframe) {
    waitForEngineToken(renderApp);
  } else {
    renderApp();
  }
}

boot();
